import React from 'react';
import { usePathname } from '@framework/next/navigation';
import { footerConfig } from './footerConfig';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import SectionFooter from '@framework/ui/Pages/Landing/Sections/Footer';
import styles from './footer.module.scss';

interface IProps {
  tenant: DataroomTenant,
}

const Footer = ({ tenant }: IProps) => (
  <SectionFooter
    config={ footerConfig(tenant, usePathname()) }
    contentClassName={ styles.Content }
  />
);

export default Footer;
